module.exports = __webpack_public_path__ + "img/language.c29ff206.svg";